import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServiceService } from '../../services/common/api-service.service';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-merchant-profile',
  templateUrl: './merchant-profile.component.html',
  styleUrls: ['./merchant-profile.component.scss']
})
export class MerchantProfileComponent implements OnInit {


  merchantForm!: FormGroup;

  merchantId: any;

  loading = false;

  categories: any[] = [];
  states: any[] = [];
  districts: any[] = [];
  cities: any[] = [];

  profilePicUrl: string | null = null;
  selectedFiles: any = {};


  constructor(

    private fb: FormBuilder,

    private apiService: ApiServiceService

  ) { }




  ngOnInit(): void {


    this.merchantId =
      localStorage.getItem('merchantId');


    this.createForm();
    this.getCategories();

    this.getCategories();
    this.getStates();

    this.getProfile();


  }







  onFileChange(event: any, key: string) {
    if (event.target.files && event.target.files.length > 0) {
      this.selectedFiles[key] = event.target.files[0];
    }
  }

  createForm() {


    this.merchantForm = this.fb.group({



      business_name: [

        '',

        Validators.required

      ],




      owner_name: [

        '',

        Validators.required

      ],




      category: [

        '',

        Validators.required

      ],




      phone: [

        '',

        Validators.required

      ],




      address_line1: [

        '',

        Validators.required

      ],




      area: [

        '',

        Validators.required

      ],




      city: [

        '',

        Validators.required

      ],




      district: [

        '',

        Validators.required

      ],




      state: [

        '',

        Validators.required

      ],




      pincode: [

        '',

        Validators.required

      ],




      years_of_experience: [

        '',

        Validators.required

      ],




      business_description: [
        '',
        Validators.required
      ]
    });

    this.merchantForm.get('state')?.valueChanges.subscribe(stateId => {
      if (stateId) {
        this.getDistricts(stateId);
      } else {
        this.districts = [];
        this.merchantForm.get('district')?.setValue('');
      }
    });

    this.merchantForm.get('district')?.valueChanges.subscribe(distId => {
      if (distId) {
        this.getCities(distId);
      } else {
        this.cities = [];
        this.merchantForm.get('city')?.setValue('');
      }
    });

  }








  getProfile() {
    this.apiService.getMerchantProfile(this.merchantId).subscribe({
      next: (res) => {
        const data = res.data;

        const doPatch = () => {
          this.profilePicUrl = data.profile_pic ? (data.profile_pic.startsWith('/') ? environment.apiUrl + data.profile_pic : data.profile_pic) : null;
          this.merchantForm.patchValue({
            business_name: data.business_name,
            owner_name: data.owner_name,
            category: data.category,
            email: data.email,
            phone: data.phone,
            address_line1: data.address_line1,
            area: data.area,
            city: data.city,
            district: data.district,
            state: data.state,
            pincode: data.pincode,
            years_of_experience: data.years_of_experience,
            business_description: data.business_description
          }, { emitEvent: false });
        };

        if (data.state) {
          this.apiService.getDistrictByState(data.state).subscribe({
            next: (dRes) => {
              this.districts = dRes.data;
              if (data.district) {
                this.apiService.getCityByDistrict(data.district).subscribe({
                  next: (cRes) => {
                    this.cities = cRes.data;
                    doPatch();
                  }
                });
              } else {
                doPatch();
              }
            }
          });
        } else {
          doPatch();
        }
      },
      error: (err) => {


        console.log(err);

      }
    })


  }





  updateProfile() {



    if (this.merchantForm.invalid) {


      this.merchantForm.markAllAsTouched();


      Swal.fire({

        title: 'Incomplete',

        text: 'Please fill all required fields',

        icon: 'warning'

      });


      return;


    }




    this.loading = true;



    const formData =

      new FormData();




    Object.keys(

      this.merchantForm.value

    )

      .forEach(key => {


        formData.append(

          key,

          this.merchantForm.value[key]

        );


      });







    Object.keys(

      this.selectedFiles

    )

      .forEach(key => {


        if (this.selectedFiles[key]) {


          formData.append(

            key,

            this.selectedFiles[key]

          );


        }


      });







    this.apiService

      .updateMerchantProfile(

        this.merchantId,

        formData

      )

      .subscribe({



        next: (res) => {



          this.loading = false;



          Swal.fire({

            title: 'Updated',

            text: 'Profile updated successfully',

            icon: 'success',

            confirmButtonColor: '#B01E3E'

          });



        },



        error: (err) => {


          this.loading = false;



          Swal.fire({

            title: 'Error',

            text: 'Unable to update profile',

            icon: 'error'

          });


        }


      })


  }

  getCategories() {
    this.apiService.getServiceCategories().subscribe({
      next: (res) => {
        this.categories = res.data;
      },
      error: (err) => console.log(err)
    });
  }

  getStates() {
    this.apiService.getState().subscribe({
      next: (res) => {
        this.states = res.data;
      },
      error: (err) => console.error(err)
    });
  }

  getDistricts(stateId: string) {
    this.apiService.getDistrictByState(stateId).subscribe({
      next: (res) => {
        this.districts = res.data;
      },
      error: (err) => console.error(err)
    });
  }

  getCities(distId: string) {
    this.apiService.getCityByDistrict(distId).subscribe({
      next: (res) => {
        this.cities = res.data;
      },
      error: (err) => console.error(err)
    });
  }

  onProfilePicChange(event: any) {
    const file = event.target.files[0];
    if (file && this.merchantId) {
      Swal.fire({
        title: 'Uploading...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.apiService.updateMerchantProfilePicture(this.merchantId, file).subscribe({
        next: (res) => {
          this.profilePicUrl = res.data.profile_pic ? (res.data.profile_pic.startsWith('/') ? environment.apiUrl + res.data.profile_pic : res.data.profile_pic) : null;
          Swal.fire('Success', 'Profile picture updated successfully', 'success');
        },
        error: (err) => {
          console.error(err);
          Swal.fire('Error', 'Failed to upload profile picture', 'error');
        }
      });
    }
  }
}